export function getVisibleQualificationCount(
  badgeWidths: number[],
  availableWidth: number,
  gap: number,
  getRemainingBadgeWidth: (count: number) => number,
): number {
  let row = 1;
  // The first badge has no leading gap.
  let rowWidth = -gap;
  let visibleCount = 0;

  for (let count = 0; count < badgeWidths.length; count++) {
    const remainingWidth = getRemainingBadgeWidth(badgeWidths.length - count);
    if (row === 1 || rowWidth + gap + remainingWidth <= availableWidth) {
      visibleCount = count;
    }

    rowWidth += gap + badgeWidths[count];
    if (rowWidth > availableWidth) {
      row++;
      rowWidth = badgeWidths[count];
    }
    if (row > 2) {
      return visibleCount;
    }
  }

  return badgeWidths.length;
}
